import { SandpackBundlerFiles } from "@codesandbox/sandpack-client";
import { Environment, endpoints } from "../config/endpoints";
import { mapCSBFilesToAnimaFiles } from "../utilities/mapAnimaFilesToCSBFiles";

interface Params {
  environment: Environment;
  sessionId: string;
  files: SandpackBundlerFiles;
  token: string;
}

export const saveChanges = async (params: Params) => {
  const csbFiles = params.files;
  const files = mapCSBFilesToAnimaFiles(csbFiles);

  const apiUrl = endpoints[params.environment];
  const res = await fetch(
    `${apiUrl}/generation_sessions/v2/${params.sessionId}/sandpack`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${params.token}`,
      },
      body: JSON.stringify({
        files,
      }),
    },
  );

  if (!res.ok) {
    throw new Error(`Failed to save project (${res.status})`);
  }

  return res.json();
};
